import { render } from "./ContributorMultiselect.vue?vue&type=template&id=7b0a044e&scoped=true"
import script from "./ContributorMultiselect.vue?vue&type=script&lang=js"
export * from "./ContributorMultiselect.vue?vue&type=script&lang=js"

import "../../../assets/css/Multiselect.min.css?vue&type=style&index=0&lang=css"
import "./ContributorMultiselect.vue?vue&type=style&index=1&id=7b0a044e&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0a044e"]])

export default __exports__